import React from "react";
import { Outlet } from "react-router-dom";
import TopNav from "./TopNav";

export default function DashboardLayout() {
  return (
    <div className="dash-root">
      <TopNav />
      <main className="dash-content">
        <Outlet />
      </main>
    </div>
  );
}
